import { events } from '@/services/wss/SystemEvents';
import ComponentNotifier from '../../../services/wss/ComponentNotifier';
import pnl3UnmatchedCache from './Pnl3UnmatchedCache';
import pnl3UnmatchedFetcher from './Pnl3UnmatchedFetcher';
import WssEventHandlerBase from '@/services/engines/WssEventHandlerBase';

const _name = 'Pnl3UnmatchedEngine';

class Pnl3UnmatchedEngine extends WssEventHandlerBase {
    _name = _name;

    bootup() {
        super.bootup();
        this.clear();

        this._unsub = this._wsNotifier.subscribe(events.OnPnl3UnmatchedUpdate_v1, this.onMessage);
    }

    clear() {
        super.clear();

        if (this._unsub) this._unsub();
    }

    /**
     * PageContent published named event — BE stuurt per sid de volledige, actuele
     * unmatched-set (geen delta, geen multi-sid batch).
     * @param {{sid: number|string, items: object[]}} data
     */
    onMessage = ({ sid, items }) => {
        try {
            pnl3UnmatchedCache.replaceForSid(sid, items);
            this._notify(sid);
        } catch (error) {
            this.logError('onMessage', error.message);
        }
    };

    /**
     * @param {number|string} sid
     */
    getUnmatched = async (sid) => {
        try {
            const cached = pnl3UnmatchedCache.getBySid(sid);
            if (cached.length) return cached;

            return await this.fetch(sid);
        } catch (error) {
            this.logError('getUnmatched', error.message);
            return [];
        }
    };

    /**
     * @param {number|string} sid
     */
    fetch = async (sid) => {
        try {
            const items = await pnl3UnmatchedFetcher.fetch(sid);
            pnl3UnmatchedCache.replaceForSid(sid, items);
            this._notify(sid);
            return items;
        } catch (error) {
            this.logError('fetch', error.message);
            return [];
        }
    };

    // notify carries only the sid — fetch() has a full set, onMessage() only a delta,
    // so the payload itself can never be trusted as "the full list"; consumers always
    // re-read pnl3UnmatchedCache.getBySid(sid) after being notified.
    _notify = (sid) => {
        ComponentNotifier.notify(_name, 'dataChanged', { sid: String(sid) });
    };
}

const pnl3UnmatchedEngine = new Pnl3UnmatchedEngine();
export default pnl3UnmatchedEngine;
